import Carousel from '../components/Carousel2';
import FAQSection from '../components/personas/CDTs/FAQ';
import Hero1 from '../components/Hero1';
import tuFIC1 from '../assets/tuFIC1.jpg';
import tuFIC2 from '../assets/tuFIC2.png';
import Simulator from '../components/personas/Simulator';
import HeroB from '../components/HeroB';
import HorizontalList from '../components/horizontalList';

function TusFICs() {
    const carouselItems = [
        { title: "Centraliza tus fondos", description: "Conecta las FICs que ya tienes y visualiza tu portafolio completo con indicadores de rentabilidad y riesgo en tiempo real." },
        { title: "Compara rentabilidades", description: "Filtra por horizonte, perfil y entidad para identificar rápidamente qué fondos están superando el mercado." },
        { title: "Descubre nuevas oportunidades", description: "Recibe recomendaciones personalizadas con base en tu perfil e intereses de liquidez." },
        { title: "Apertura 100% digital", description: "Diligencia los formularios en línea, firma electrónicamente y deja que nuestro equipo se encargue del trámite con cada entidad." },
        { title: "Alertas inteligentes", description: "Configura notificaciones sobre cambios en la tasa, vencimientos o metas de rendimiento para no perder oportunidades." },
        { title: "Reportes descargables", description: "Genera reportes en PDF o Excel para tus comités internos o para compartir con tus asesores financieros." },

    ];

    return (
        <div>
            <Hero1 imagen={tuFIC1} titulo="Administra tus Fondos de Inversión Colectiva" descripcion="Desde un solo lugar: analiza, invierte y organiza tu información en un mismo espacio."/>
            
            <HorizontalList
                items={[
                    { label: "Simulador", targetId: "simulador" },
                    { label: "¿Cómo funciona?", targetId: "como-funciona" },
                    { label: "Beneficios", targetId: "beneficios" },
                    { label: "Preguntas frecuentes", targetId: "faq" }
                ]}
            />
            <section id="simulador" className="scroll-mt-48">
                <Simulator titulo='Simula tu FIC' tipo='fondo de inversión colectiva'/>
            </section>
            <section id="como-funciona" className="scroll-mt-24">
                <HeroB
                    imagen={tuFIC2}
                    titulo="¿Cómo funciona?"
                    items={[
                        "Conecta tus FICs actuales y define tu perfil de riesgo para personalizar la plataforma.",
                        "Simula y compara escenarios de rentabilidad con datos de todas las sociedades comisionistas.",
                        "Solicita la apertura o traslado y recibes acompañamiento de nuestro equipo hasta la formalización."
                    ]}
                />
            </section>
            <section id="beneficios" className="scroll-mt-24">
                <Carousel items={carouselItems} />
            </section>
            <section id="faq" className="scroll-mt-24">
                <FAQSection />
            </section>
            <hr className="w-full border-t border-black" />
        </div>
    );
}
export default TusFICs;
